document.addEventListener("DOMContentLoaded", () => {

  const logo = document.querySelector(".oddcell-header-logo");

  if (logo) {
    gsap.from(logo, {
      opacity: 0,
      y: -20,
      duration: 2.5,
      delay: 0.5,
      ease: "power1.out"
    });
  }

});